import { Typography } from '@mui/material';

import { ElevatorDetailPage } from '~/components/compliance/detailPage/ElevatorDetailPage';
import { useElevatorDetail } from '~/components/compliance/detailPage/useElevatorDetail';
import { RowPreviewPanel } from '~/components/rowPreview/RowPreviewPanel';
import type { RowPreview } from '~/components/rowPreview/useRowPreview';

export function ElevatorPreviewContent({ carId }: { carId: string }) {
  const { compliance, car, carLoading, error, isLoading, refresh } = useElevatorDetail(carId);

  if (error && !compliance) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 3 }}>
        This elevator couldn’t be loaded.
      </Typography>
    );
  }
  return (
    <ElevatorDetailPage
      key={carId}
      compliance={compliance}
      car={car}
      carLoading={carLoading}
      isLoading={isLoading}
      refresh={() => void refresh()}
      onBack={null}
      variant="preview"
    />
  );
}

/** `getCarId` maps a row to its car; rows without one never open a preview. */
export function ElevatorPreviewPanel({
  rowPreview,
  getCarId = (rowId) => rowId,
  onOpenFullPage,
}: {
  rowPreview: RowPreview;
  getCarId?: (rowId: string) => string | null;
  onOpenFullPage: (carId: string) => void;
}) {
  return (
    <RowPreviewPanel
      rowPreview={rowPreview}
      ariaLabel="Elevator preview"
      onOpenFullPage={(rowId) => {
        const carId = getCarId(rowId);
        if (carId) onOpenFullPage(carId);
      }}
    >
      {(rowId) => {
        const carId = getCarId(rowId);
        return carId ? <ElevatorPreviewContent carId={carId} /> : null;
      }}
    </RowPreviewPanel>
  );
}
